import { service } from '../default/default_service';
import { AnalyticsCustomEvent } from './custom_events';

export function captureProductEvent(event: AnalyticsCustomEvent) {
  service().captureEvent(event.name, event.properties);
}
